import FlyerHeadLogo from './FlyerHeadLogo'
import FlyerHeadTitle from './FlyerHeadTitle'
import FlyerFoot from './FlyerFoot'
import FlyerItemsList from './FlyerItemsList'

const FlyerSection = ({
    flyerData,
    movies,
    performances,
    colors, 
    iconsColor,
    items,
    flyerServerData,
    section, 
    week,
    side,
    translation,
    currentCinemaId,
    logoData, 
    currentPeriodeEndDate, 
    currentPeriodeStartDate, 
    formartedCurrentPeriodeStartDate,
    formartedCurrentPeriodeEndDate,
    cinemaData, 
    onLoadImg,
}) => {
    const isTitlePage = 'outside' === side && 'right' === section

    return <div className={'section ' + section}>
        {isTitlePage ? (
            <>
                <FlyerHeadTitle
                    logoData={logoData}
                    flyerSettings={flyerData.flyerSettings}
                    formartedCurrentPeriodeStartDate={formartedCurrentPeriodeStartDate}
                    formartedCurrentPeriodeEndDate={formartedCurrentPeriodeEndDate}
                />

                <FlyerItemsList
                    listClassName="grid-images-list"
                    items={items.grid}
                    flyerData={flyerData}
                    currentCinemaId={currentCinemaId}
                    cinemaData={cinemaData}
                    translation={translation}
                    movies={movies}
                    week={week}
                    flyerServerData={flyerServerData}
                    colors={colors}
                    iconsColor={iconsColor}
                    performances={performances}
                    currentPeriodeStartDate={currentPeriodeStartDate}
                    currentPeriodeEndDate={currentPeriodeEndDate}
                    onLoadImg={onLoadImg}
                />

                <FlyerItemsList
                    items={items.content}
                    flyerData={flyerData}
                    currentCinemaId={currentCinemaId}
                    cinemaData={cinemaData}
                    translation={translation}
                    flyerServerData={flyerServerData}
                    week={week}
                    colors={colors}
                    iconsColor={iconsColor}
                    performances={performances}
                    currentPeriodeStartDate={currentPeriodeStartDate}
                    currentPeriodeEndDate={currentPeriodeEndDate}
                    onLoadImg={onLoadImg}
                />

                <FlyerFoot
                    flyerSettings={flyerData.flyerSettings}
                    cinemaData={cinemaData}
                />          
            </>

        ) : (
            <>
                {'inside' === side && 'middle' === section && <FlyerHeadLogo
                    logoData={logoData}
                    flyerSettings={flyerData.flyerSettings}
                    formartedCurrentPeriodeStartDate={formartedCurrentPeriodeStartDate}
                    formartedCurrentPeriodeEndDate={formartedCurrentPeriodeEndDate}
                />}
     
                <FlyerItemsList
                    items={items}
                    flyerData={flyerData}
                    currentCinemaId={currentCinemaId}
                    cinemaData={cinemaData}
                    translation={translation}
                    movies={movies}
                    week={week}
                    flyerServerData={flyerServerData}
                    colors={colors}
                    iconsColor={iconsColor}
                    performances={performances}
                    currentPeriodeStartDate={currentPeriodeStartDate}
                    currentPeriodeEndDate={currentPeriodeEndDate}
                    onLoadImg={onLoadImg}
                />
            </>
        )}
    </div>
}

export default FlyerSection